import React from "react";
import taxi from "../images/taxi-image.png";
import MyButton from "../components/MyButton";

const Finish = (props) => {
  const setCurrentPage = props.changePage;
  const score = props.score;


  const goBack = () => {
    // Your custom button click logic here
    setCurrentPage("main");
  };



  return (
    <div className="mx-10">
      <img src={taxi} className="mb-10" alt="taxi" />
      <div className="text-2xl mb-5">Quiz acabat!</div>
      <div className="text-4xl mb-7">Has encertat un 
      <div className="font-bold">{Math.floor(score * 100)} %</div>  de les preguntes</div>
      <div className="button-Container">
        <MyButton label="Back" onPress={goBack} color="red" />
      </div>
    </div>
  );
};
export default Finish;
